export default {
  path: 'dashboards',
  name: 'dashboards',
  component: () => import('@/views/Admin/Dashboards/Dashboards.vue'),
  meta: {
    labels: ['Dashboards'],
    customColors: ['#FF7A13', '#FF2C44', '#FF1B7B', '#AD22D7'],
    requiresPermission: 'isPermissionManager',
  },
  children: [
    {
      path: 'create',
      name: 'create-dashboard',
      component: () => import('@/views/Admin/Dashboards/CreateDashboard.vue'),
      meta: {
        labels: ['Criar Dashboard'],
        requiresPermission: 'isPermissionManager',
      },
    },
    {
      path: 'edit/:name',
      name: 'edit-dashboard',
      component: () => import('@/views/Admin/Dashboards/EditDashboard.vue'),
      meta: {
        labels: ['Editar Dashboard'],
        requiresPermission: 'isPermissionManager',
      },
    },
  ],
};
